<div class="workspace-outer-container">
  <div class="workspace-inner-container">
    <properties-grid [hidden]="!showGrid" [workspace]="this"></properties-grid>
    <properties-form [oid]="oid" *ngIf="!showGrid && oid !== null"
                     [workspace]="this"
                     [showPrevBtn]="previousButtonEnabled"
                     [showNextBtn]="nextButtonEnabled"
                     (showPrevious)="showPrevious()"
                     (showNext)="showNext()">
    </properties-form>

    <calculation-model-assign *ngIf="assignCalculationModelProjectId" [(oid)]="assignCalculationModelProjectId"></calculation-model-assign>

  </div>
</div>

<assign-properties-dialog></assign-properties-dialog>
